<app-list
    *ngIf="!isLoadData" [data]="data" [showSearch]="showSearch"
    (appInput)="input$$.next($event)" (appSelect)="select($event)" (appScrolled)="onScrolled()" class="select-list-height"
    [class.p-dialog-style]="isDialog">
</app-list>
